// extracted by mini-css-extract-plugin
export default {"pagination":"d340cf39f6","pageItem":"_3d69bf044e _0a821e3896 f3787629d8","active":"adb5afa8af","disabled":"e87761e22a","arrowIcon":"b2b657d60e"};